
import { FabrixIcon, formatDate } from "fabrix/common";
import { useCurrentUser, useIcon, useSettings } from "fabrix/hooks";
import svg from './ownerlogo_white.svg';
import { useSelector } from "react-redux";
import { AppState } from "fabrix/redux/store";
import { SettingsState } from "fabrix/redux/settings-slice";

/**
 * Displays the portal footer with release metadata and owner branding.
 * @returns Footer section showing version information.
 */
export default function Footer() {
    const _settings = useSelector<AppState>(state => state.settings) as SettingsState;
    const _currentUser = useCurrentUser();
    const icon = useIcon();



    let version = `${_settings.version} : ${formatDate(_settings.releaseDate)}`



    return (

        <div className='fbx-footer flex justify-content-between' >
            <div className='flex align-items-center justify-content-center'>

            </div>
            <div className='flex align-items-center justify-content-center fbx-footer-version'>{version}</div>


        </div>
    )
}